import cn from 'classnames/bind'

import { ColumnKey } from './table-columns'
import styles from './header-cell.scss'



const cx = cn.bind(styles)

export const headerCell = <CellData extends { columnKey: string, value?: string | null }>(
  cellData?: CellData,
) => {
  if (!cellData) {
    return <span>{'Поле не задано'}</span>
  }

  const { value, columnKey } = cellData
  const className = cx(styles.root, {
    special: columnKey === ColumnKey.BudgetExpencesFrom1To4,
    specialWidth: /(parentsExpenses|budgetExpencesFrom1To11|budgetExpencesFrom1To11Total|budgetExpencesFrom1To4|total)/.test(columnKey)
  })

  if ('value' in cellData) {
    return <span className={className}>{value === null ? '—' : value}</span>
  }

  return <span>{'—'}</span>
}
